import { createFileRoute } from '@tanstack/react-router'
import { AvailabilityRequestsPage } from '@/features/scheduler/pages/availability-requests-page'

export const Route = createFileRoute(
  '/_authenticated/_organization/scheduler/availability-requests'
)({
  component: AvailabilityRequestsPage,
})
